export default "__VITE_ASSET__03g4TX3p__"